import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { isMgbwWebsite, isSuryaWebsite } from "@tSurya/Common/Utilities/websiteUtils";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const isSurya = isSuryaWebsite();
const isMgbw = isMgbwWebsite();

addToListModalStyles.modal = {
    size: 350,
    // On MGBW the brand theme forces a transparent, borderless close button.
    // Re-create the Surya look (compact square bordered X) for this modal only.
    closeButtonProps: isMgbw
        ? {
              size: 36,
              css: css`
                  background: transparent !important;
                  border: 1px solid ${getColor("text.main")} !important;
                  border-radius: 0 !important;
                  width: 36px !important;
                  height: 36px !important;
                  min-width: 36px !important;
                  padding: 0 !important;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  &:hover,
                  &:focus,
                  &:active,
                  &:focus-visible {
                      background: transparent !important;
                      border: 1px solid ${getColor("text.main")} !important;
                      outline: none !important;
                      box-shadow: none !important;
                  }

                  svg {
                      width: 20px !important;
                      height: 20px !important;
                  }
                  svg,
                  svg * {
                      color: ${getColor("text.main")} !important;
                  }
              `,
          }
        : undefined,
    closeButtonIconProps: isMgbw
        ? {
              size: 20,
              color: "text.main",
          }
        : undefined,
    cssOverrides: {
        modalBody: css`
            overflow-y: visible;
        `,
        modalTitle: css`
            padding: 10px 20px;
            color: ${COLORS.text.main} !important;
            font-family: ${TYPOGRAPHY.fontFamily.title} !important;
            font-style: normal !important;
            font-weight: ${TYPOGRAPHY.weight.bold} !important;
            font-size: ${TYPOGRAPHY.size.larger} !important;
            line-height: ${TYPOGRAPHY.lineHeight.lmedium} !important;

            h1,h2,h3,h4,h5,h6 {
                color: ${COLORS.text.main} !important;
                font-family: ${TYPOGRAPHY.fontFamily.title} !important;
                font-style: normal !important;
                font-weight: ${TYPOGRAPHY.weight.bold} !important;
                font-size: ${TYPOGRAPHY.size.larger} !important;
                line-height: ${TYPOGRAPHY.lineHeight.lmedium} !important;
            }
        `,
        modalContent: css`
            padding: 20px;
        `,
    },
};
addToListModalStyles.descriptionText = {
    as: "p",
    css: css`
        color: ${COLORS.text.main};
    `,
};
addToListModalStyles.listsSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
            label {
                color: ${COLORS.text.main};
            }
        `,

        list: css`
            max-height: 300px;
            ::-webkit-scrollbar {
                width: 5px;
            }

            ::-webkit-scrollbar-thumb {
                background-color: ${COLORS.text.main};
            }
        `,
    },
};
addToListModalStyles.newListInput = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
            label {
                color: ${COLORS.text.main};
            }
        `,
    },
};
addToListModalStyles.cancelButton = {
    variant: "secondary",
    css: css`
        margin-left: 10px;
        border-radius: 0px;
        padding: 10px 34px;
        background: ${COLORS.background.main};
        border: 2px solid ${COLORS.primary.base} !important;
        span[class^="TypographyStyle"] {
            color: ${COLORS.primary.base};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            opacity: 0.3;
            background: none !important;
            color: ${COLORS.primary.base};
            span[class^="TypographyStyle"] {
                color: ${COLORS.primary.base};
            }
        }
    `,
};
addToListModalStyles.addButton = {
    css: css`
        margin-left: 10px;
        border-radius: 0;
        padding: 10px 34px;
        background: ${COLORS.primary.base};
        border: 2px solid ${COLORS.primary.base};

        span[class^="TypographyStyle"] {
            color: ${COLORS.primary.contrast};
            font-size: 14px;
            line-height: ${TYPOGRAPHY.lineHeight.base};
        }
        &:hover {
            ${css`
                background: ${COLORS.darkerGrey};
                /* border: 2px solid  background: ${COLORS.accent.main}; */
                span[class^="TypographyStyle"] {
                color: ${COLORS.primary.contrast};
            }`}
        }
    `,
};
